<template>
  <div>
    <div class="mod-extra-segment-pc">
      <div
        :class="[
          'mod-segment-wrapper',
          current.segmentIndex === index ? 'actived' : '',
          ifInternational?.() && currentProduct !== 'seat' && item[currentProduct]?.length === 0 ? 'disabled' : ''
        ]"
        v-for="(item ,index) in itinerarys"
        :key="index"
      >
        <div class="segment clearfix">
          <span>{{item.orgDsts[0].departureName}}</span>
          <img
            src="../img/extra-flight.png"
            alt=""
          >
          <span>{{item.orgDsts[0].arrivalName}}</span>
        </div>
        <div class="segment-info clearfix">
          <div>
            <span class="f-b">航班号：</span>
            <span>{{item.orgDsts[0].flightNo}}</span>
          </div>
          <div>
            <span class="f-b">起飞时间：</span>
            <span>{{item.orgDsts[0].departureTime}}</span>
          </div>
          <!-- TODO: HU和CN暂时无法吐出权益，等接口支持 -->
          <template v-if="!['HU', 'CN'].includes(item.orgDsts[0].airlineCode)">
            <div>
              <span class="f-red f-b">免费托运行李：</span>
              <span class="f-red">{{ getBenefit(item, index, 'luggage') }}</span>
            </div>
            <div v-if="!ifInternational?.()">
              <span class="f-red f-b">免费餐食：</span>
              <span class="f-red">{{ getBenefit(item, index,  'meal') }}</span>
            </div>
          </template>
        </div>
        <div
          :class="[
            'passenger',
            current.segmentIndex === index && current.passengerIndex === idx ? 'left-sel' : '',
            ifInternational?.() && (passenger.passengerType === 'INF' || passenger.passengerType === 'ADT' && currentProduct === 'seat' && passenger.hasAccompany) ? 'disabled' : ''
          ]"
          :key="idx"
          @click="selectPassenger(index, idx)"
          v-for="(passenger, idx) in item?.passengers"
        >
          <span>{{passenger.fullName}}</span>
          <div :class="['right-status']">
            <l8-icon
              v-if="passenger.select && passenger.select.luggage && passenger.select.luggage.length"
              class="l8-icon icon"
              type="icon-category-luggage"
            />
            <l8-icon
              v-if="passenger.select && passenger.select.meal && passenger.select.meal.length"
              class="l8-icon icon"
              type="icon-category-meal"
            />
            <l8-icon
              v-if="passenger.select && passenger.select.seat && passenger.select.seat.length"
              class="l8-icon icon"
              type="icon-category-seat"
            />
             <l8-icon
              v-if="passenger.select && passenger.select.itinerary && passenger.select.itinerary.length"
              class="l8-icon icon"
              type="icon-category-itinerary"
            />
            <l8-icon
              v-if="passenger.select && ((passenger.select.insurance && passenger.select.insurance.length) || (passenger.select.lugInsurance && passenger.select.lugInsurance.length))"
              class="l8-icon icon"
              type="icon-category-insurance"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="mod-extra-segment-phone">
      <div class="segment-wrapper">
        <div
          :class="['segment', current.segmentIndex === index ? 'on' : '']"
          v-for="(item ,index) in itinerarys"
          :key="index"
          @click="selectSegment(index)"
        >
          <span>{{item.orgDsts[0].departureName}}-{{item.orgDsts[0].arrivalName}}</span>
          <span>起飞时间:{{item.orgDsts[0].departureTime}}</span>
        </div>
      </div>
      <a-tabs
        class="mod-passenger-wrapper"
        type="card"
        v-if="itinerarys && itinerarys.length > 0"
      >
        <a-tab-pane
          :tab="passenger.fullName"
          @change="selectPassenger(current.segmentIndex, idx)"
          v-for="(passenger,idx) in itinerarys[current.segmentIndex]?.passengers"
          :key="idx"
        ></a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import '@/components/l8-icon'
import { Tabs } from 'ant-design-vue'
Vue.use(Tabs)
const mainSettings = window.__MICRO_ROOT__ ?? {}

export default {
  props: {
    itinerarys: {
      type: Array
    },
    current: {
      type: Object,
      default: function () {
        return {
          segmentIndex: 0,
          passengerIndex: 0
        }
      }
    },
    currentProduct: String
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  methods: {
    selectPassenger (segmentIndex = 0, passengerIndex = 0) {
      this.$emit('select', { segmentIndex: segmentIndex, passengerIndex })
    },
    selectSegment (segmentIndex = 0) {
      this.$emit('select', { segmentIndex, passengerIndex: 0 })
    },
    // 区分展示权益，非8L婴儿的行李及所有旅客类型餐食权益不展示
    getBenefit (value, index, name) {
      const { passengerIndex, segmentIndex } = this.current
      let text = '-'
      if (index === segmentIndex) {
        if (value.orgDsts[0].airlineCode !== mainSettings.airline && value?.passengers[passengerIndex].passengerType === 'INF') {
          text = '-'
        } else {
          if (name === 'luggage') {
            text = value?.benefits?.luggage || '无'
          } else if (name === 'meal') {
            text = value?.benefits?.meal || '无'
          }
        }
      }
      return text
    }
  }
}
</script>

<style lang="less">
.mod-extra-book {
  background: #f5f5f5;
}

.mod-segment-wrapper {
  width: 328px;
  text-align: center;
  color: #666;
  vertical-align: middle;
  margin-bottom: 20px;
  border-radius: 16px;
  background: #fff;
  border: none;
  transition: all 0.5s;
  &:hover, &.actived:not(:only-child) {
    transform: scale(1.05, 1.05);
  }

  &.disabled {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
    background-color: #ddd;
  }

  .segment {
    font-size: 18px;
    font-weight: bold;
    line-height: 72px;
    border-bottom: solid 1px #eee;

    img {
      width: 37px;
      height: 18px;
      margin: 0 25px;
    }
  }

  .segment-info {
    font-size: 12px;
    line-height: 20px;
    padding: 10px;
    box-sizing: border-box;

    & > div {
      text-align: left;
      line-height: 1.8;
    }

    p {
      margin-bottom: 0;
    }
  }

  .passenger {
    padding: 0px 20px;
    font-size: 14px;
    height: 58px;
    box-sizing: border-box;
    line-height: 58px;
    cursor: pointer;
    border-top: 1px solid #eee;

    & > span {
      float: left;
    }

    .right-status {
      float: right;
      color: @primary-color;
      line-height: 58px;

      .icon {
        margin-left: 10px;
        vertical-align: middle;
      }
    }

    &.disabled {
      pointer-events: none;
      cursor: not-allowed;
      opacity: 0.5;
      background-color: #ddd;
    }

  }

  .left-sel {
    color: #fff;
    background: @primary-color;
    position: relative;
    &:last-child{
      border-bottom-left-radius: 16px;
    }
    &::after {
      content: "";
      width: 0;
      height: 0;
      border-top: 29px solid transparent;
      border-bottom: 29px solid transparent;
      border-left: 8px solid @primary-color;
      position: absolute;
      right: -8px;
    }

    .right-status {
      color: #fff;
    }
  }

  .f-red {
    color: @primary-color;
  }
  .w-86 {
    width: 84px;
  }
  .w-50 {
    width: 50px;
  }
  .w-60 {
    width: 60px;
  }
  .f-b {
    font-weight: bold;
  }
}
.mod-extra-segment-phone {
  display: none;
}
@media only screen and (max-width: 768px) {
  .mod-extra-segment-pc {
    display: none;
  }
  .mod-extra-segment-phone {
    display: block;
    .segment-wrapper {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 68px;
      font-size: 14px;
      border-bottom: solid 1px #afafaf;
      border-left: solid 1px #afafaf;

      .segment {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: solid #afafaf;
        border-width: 1px 1px 0 0;
        width: 50%;
        background: #f5f5f5;
      }
      .on {
        background: @primary-color;
        color: #fff;
      }
    }
  }
}
</style>
